import { GetObjectCommand, S3Client } from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';

const BUCKET = import.meta.env.VITE_S3_BUCKET;
const REGION = import.meta.env.VITE_S3_REGION;
const ACCESS_KEY = import.meta.env.VITE_S3_ACCESS_KEY;
const SECRET_ACCESS_KEY = import.meta.env.VITE_S3_SECRET_KEY;

// Retrieve image data from aws s3 bucket
const getFile = async (key: string) => {
  const s3 = new S3Client({
    credentials: {
      accessKeyId: ACCESS_KEY,
      secretAccessKey: SECRET_ACCESS_KEY,
    },
    region: REGION,
  });

  const command = new GetObjectCommand({ Bucket: BUCKET, Key: key });

  // @ts-ignore
  return getSignedUrl(s3, command, { expiresIn: 900 });
};

export default getFile;
